import React, { useEffect, useState, Suspense } from "react";

const Hero3DCanvasLazy = React.lazy(() =>
  import("./Hero3DCanvas").then((mod) => ({ default: mod.Hero3DCanvas }))
);

export function Hero3DWrapper({ className = "" }: { className?: string }) {
  const [shouldLoad3D, setShouldLoad3D] = useState(false);

  useEffect(() => {
    // Only load 3D Canvas on desktop viewports (>=1024px) and fine pointer devices (non-touch)
    if (typeof window !== "undefined") {
      const isDesktop = window.innerWidth >= 1024;
      const isTouch = window.matchMedia("(pointer: coarse)").matches;
      if (!isDesktop || isTouch) return;

      const scheduleLoad = () => {
        if ("requestIdleCallback" in window) {
          (window as any).requestIdleCallback(() => setShouldLoad3D(true), { timeout: 3500 });
        } else {
          setTimeout(() => setShouldLoad3D(true), 2000);
        }
      };

      if (document.readyState === "complete") {
        scheduleLoad();
      } else {
        window.addEventListener("load", scheduleLoad, { once: true });
        return () => window.removeEventListener("load", scheduleLoad);
      }
    }
  }, []);

  const staticPlaceholder = (
    <div className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`} aria-hidden="true">
      {/* Lightweight Static Glass Background — zero CLS */}
      <div className="absolute top-10 left-6 sm:left-24 w-28 h-28 rounded-2xl bg-primary/5 border border-primary/10 backdrop-blur-sm transform -rotate-12" />
      <div className="absolute bottom-16 right-8 sm:right-28 w-36 h-36 rounded-3xl bg-blue-500/5 border border-blue-500/10 backdrop-blur-sm transform rotate-6" />
    </div>
  );

  if (!shouldLoad3D) {
    return staticPlaceholder;
  }

  return (
    <Suspense fallback={staticPlaceholder}>
      <Hero3DCanvasLazy className={className} />
    </Suspense>
  );
}
